// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { getDefaultSlots } from '@progress/kendo-vue-common';
/**
 * The GridColumnMenuItemGroup that will be used inside the Grid ColumnMenu.
 */

var GridColumnMenuItemGroup = {
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var defaultSlot = getDefaultSlots(this);
    return h("div", {
      "class": "k-columnmenu-item-wrapper"
    }, [defaultSlot]);
  }
};
export { GridColumnMenuItemGroup };


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-vue-grid/dist/es/columnMenu/GridColumnMenuItemGroup.js
// module id = 228
// module chunks = 93